import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bb-bg flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-white/15 border-t-[#1c3df5] animate-spin"></div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export const RequireAdmin = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bb-bg flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-white/15 border-t-[#ff7a1a] animate-spin"></div>
      </div>
    );
  }
  if (!user || !(user.role === "admin" || user.role === "super_admin")) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};
